// src/components/AppHeader.jsx
import React from "react";
import { Search, Sun, Moon } from "lucide-react";

const AppHeader = ({ search, onSearchChange, theme, onToggleTheme }) => {
    const isDark = theme === "dark";

    return (
        <header className="rounded-2xl border border-gray-200 bg-white/90 dark:bg-slate-900/90 backdrop-blur px-4 py-4 md:px-6 md:py-5 shadow-sm flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div>
                <div className="flex items-center gap-3">
                    {/* Logo */}
                    <img
                        src="/logo.png"
                        alt="Logo"
                        className="w-12 h-12 rounded-full object-cover"
                    />

                    {/* Title */}
                    <div className="flex items-center gap-2">
                        <h1 className="text-3xl md:text-4xl font-black tracking-tight text-gray-900 dark:text-slate-50 flex items-center gap-1">
                            <span className="text-red-600">BRIEFLY</span>
                            <span>CA</span>
                        </h1>

                        {/* Badge */}
                        <span className="inline-flex items-center rounded-full 
        bg-red-50/80 dark:bg-red-900/40 
        px-3 py-0.5 text-[11px] font-semibold uppercase tracking-wide 
        text-red-700 dark:text-red-300 
        border border-red-100/70 dark:border-red-900/60"
                        >
                            60-second reads
                        </span>
                    </div>
                </div>

                <p className="text-sm md:text-base text-gray-600 dark:text-slate-300 mt-1">
                    Canada’s latest headlines, compressed into fast, focused summaries.
                </p>
            </div>


            <div className="w-full md:w-auto flex flex-col gap-2 md:items-end">
                <div className="flex items-center gap-2 w-full md:w-auto">
                    {/* Search */}
                    <div className="relative flex items-center bg-gray-50 dark:bg-slate-800 rounded-full px-4 py-2 shadow-inner border border-gray-200 dark:border-slate-700 w-full md:w-auto">
                        <Search className="text-gray-400 dark:text-slate-400 mr-3" size={18} />
                        <input
                            type="text"
                            placeholder="Search headlines or summaries…"
                            className="w-full md:w-72 bg-transparent outline-none text-sm md:text-base placeholder-gray-500 dark:placeholder-slate-400 text-gray-900 dark:text-slate-100"
                            value={search}
                            onChange={(e) => onSearchChange(e.target.value)}
                        />
                    </div>

                    {/* Dark mode toggle */}
                    <button
                        type="button"
                        onClick={onToggleTheme}
                        className="flex items-center justify-center rounded-full border border-gray-200 dark:border-slate-600 bg-white dark:bg-slate-800 h-10 w-10 shadow-sm hover:shadow-md transition-all"
                        aria-label="Toggle dark mode"
                    >
                        {isDark ? (
                            <Sun className="h-5 w-5 text-yellow-300" />
                        ) : (
                            <Moon className="h-5 w-5 text-slate-700" />
                        )}
                    </button>
                </div>
                <p className="text-[11px] text-gray-400 dark:text-slate-500 text-right">
                    Try topics like “housing”, “elections”, "technology..."
                </p>
            </div>
        </header>
    );
};

export default AppHeader;
